<script>
import mediaApi from "@/helpers/media/media-api.js";
import MediaPreview from "@/components/media/MediaPreview.vue";
import Swal from "sweetalert2";

export default {
  name: "MediaEditModal",
  components: { MediaPreview },
  props: {
    media: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        name: "",
        alt: "",
      },
      loading: false,
      replacing: false,
      pendingFile: null,
    };
  },
  computed: {
    modalTitle() {
      return this.media?.id ? "Editar archivo multimedia" : "Archivo multimedia";
    },
  },
  watch: {
    media: {
      immediate: true,
      handler(newMedia) {
        if (newMedia) {
          this.form.name = newMedia.name || "";
          this.form.alt = newMedia.alt || "";
          this.pendingFile = null;
        }
      },
    },
  },
  methods: {
    onFileChange(event) {
      const file = event.target.files?.[0];
      this.pendingFile = file || null;
      if (file && !this.form.name) {
        this.form.name = file.name;
      }
    },
    async submitForm() {
      if (!this.media?.id) return;
      this.loading = true;
      try {
        const updateResponse = await mediaApi.update(this.media.id, {
          name: this.form.name,
          alt: this.form.alt,
        });

        let updatedMedia = updateResponse.data.data;

        if (this.pendingFile) {
          const confirm = await Swal.fire({
            title: "¿Reemplazar archivo?",
            text: "El archivo anterior se eliminará del servidor. Esta acción no se puede deshacer.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Reemplazar",
            cancelButtonText: "Cancelar",
          });

          if (confirm.isConfirmed) {
            this.replacing = true;
            const response = await mediaApi.replaceFile(this.media.id, this.pendingFile);
            updatedMedia = response.data.data;
          }
        }

        this.$emit("success", updatedMedia);
        this.$bvModal.hide("ModalMediaEdit");
      } catch (error) {
        console.error("Error saving media:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo guardar el archivo multimedia.",
        });
      } finally {
        this.loading = false;
        this.replacing = false;
      }
    },
  },
};
</script>

<template>
  <b-modal id="ModalMediaEdit" :title="modalTitle" hide-footer size="lg">
    <div v-if="media" class="row">
      <div class="col-md-4 text-center mb-3 mb-md-0">
        <MediaPreview :item="media" size="140px" />
        <p class="small text-muted mt-2 mb-0">{{ media.mime_type }}</p>
      </div>
      <div class="col-md-8">
        <div class="form-group">
          <label>Nombre</label>
          <input v-model="form.name" type="text" class="form-control" required />
        </div>
        <div class="form-group">
          <label>Texto alternativo</label>
          <input v-model="form.alt" type="text" class="form-control" />
        </div>
        <div class="form-group">
          <label>Reemplazar archivo</label>
          <input type="file" class="form-control-file" @change="onFileChange" />
          <small v-if="pendingFile" class="text-muted d-block mt-1">
            Nuevo archivo: {{ pendingFile.name }} ({{ Math.round(pendingFile.size / 1024) }} KB)
          </small>
        </div>
        <div class="form-group mb-0">
          <label class="d-block">URL</label>
          <input :value="media.url" type="text" class="form-control" readonly />
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mt-3">
      <button type="button" class="btn btn-secondary mr-2" @click="$bvModal.hide('ModalMediaEdit')">
        Cancelar
      </button>
      <button
        type="button"
        class="btn btn-primary"
        :disabled="loading || replacing"
        @click="submitForm"
      >
        {{ loading || replacing ? "Guardando..." : "Guardar" }}
      </button>
    </div>
  </b-modal>
</template>
